import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import Switch from 'react-bootstrap-switch';
import { Field, FieldProps, FieldRenderProps, useField, useForm } from 'react-final-form';

interface Props extends FieldProps<HTMLInputElement, FieldRenderProps<any>> {
  name: string;
  label?: ReactNode;
  disabled?: boolean;
  onChange?: (event: any) => void;
  onText?: string;
  offText?: string;
  isWide?: boolean;
}

export const SwitchToggleField: FC<Props> = ({
  label,
  name,
  disabled,
  onChange,
  onText = 'ON',
  offText = 'OFF',
  isWide,
  ...fieldProps
}) => {
  const { change: changeForm } = useForm();
  const {
    input: { value },
  } = useField(name, {
    subscription: { value: true, error: true, submitError: true, touched: true },
  });

  const handleChange = event => {
    changeForm(name, event.state.value);
    if (onChange) {
      onChange(event.state.value);
    }
  };

  return (
    <>
      {label && (
        <>
          <label htmlFor={name}>{label}</label>
          <br />
        </>
      )}
      <Field hidden component="input" type="checkbox" {...fieldProps} name={name} />
      <Switch
        value={value}
        onColor="success"
        onText={onText}
        offColor="success"
        offText={offText}
        handleWidth={500}
        wrapperClass={classNames('wrapper', { 'oath-switch--wide': isWide })}
        onChange={handleChange}
        disabled={disabled}
      />
    </>
  );
};
